jQuery(function ($) {
  $('.sectors__slider').each(function () {
    const $slider = $(this)
    const $track = $slider.find('[data-sectors-track]')

    if (!$track.length) return

    $track.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: false,
      speed: 400,
      swipeToSlide: true,
      arrows: true,
      prevArrow: $slider.find('[data-sectors-prev]'),
      nextArrow: $slider.find('[data-sectors-next]'),
      dots: true,
      appendDots: $slider.find('[data-sectors-dots]'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
  })

  $('.featured-banner__slider').each(function () {
    const $slider = $(this)
    const $track = $slider.find('[data-featured-track]')

    if (!$track.length) return

    $track.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      infinite: true,
      fade: true,
      speed: 600,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      arrows: true,
      prevArrow: $slider.find('[data-featured-prev]'),
      nextArrow: $slider.find('[data-featured-next]'),
      dots: true,
      appendDots: $slider.find('[data-featured-dots]'),
    })

    $(window).on('resize orientationchange', function () {
      $track.slick('setPosition')
    })
  })

  $('.member-deals__slider').each(function () {
    const $slider = $(this)
    const $row = $slider.closest('.member-deals__row')
    const $track = $slider.find('[data-member-deals-track]')

    if (!$track.length) return

    $track.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      speed: 400,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true,
      prevArrow: $row.find('[data-member-deals-prev]'),
      nextArrow: $row.find('[data-member-deals-next]'),
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    })
  })

  $('.why-hmt__slider').each(function () {
    const $slider = $(this)
    const $track = $slider.find('[data-why-hmt-track]')

    if (!$track.length) return

    $track.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      speed: 400,
      swipeToSlide: true,
      arrows: true,
      prevArrow: $slider.find('[data-why-hmt-prev]'),
      nextArrow: $slider.find('[data-why-hmt-next]'),
      dots: true,
      appendDots: $slider.find('[data-why-hmt-dots]'),
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
  })

  $('.testimonials__slider').each(function () {
    const $slider = $(this)
    const $panel = $slider.closest('.testimonials__panel')
    const $track = $slider.find('[data-testimonials-track]')

    if (!$track.length) return

    const setProgress = (slick, current) => {
      const total = slick.slideCount || 1
      $panel.css('--testimonials-progress', `${((current + 1) / total) * 100}%`)
    }

    $track.on('init', (event, slick) => setProgress(slick, slick.currentSlide))
    $track.on('afterChange', (event, slick, current) => setProgress(slick, current))

    $track.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      infinite: true,
      fade: true,
      speed: 400,
      swipeToSlide: true,
      arrows: true,
      prevArrow: $panel.find('[data-testimonials-prev]'),
      nextArrow: $panel.find('[data-testimonials-next]'),
      dots: false,
    })
  })

  $('.news__slider').each(function () {
    const $slider = $(this)
    const $track = $slider.find('[data-news-track]')

    if (!$track.length) return

    $track.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      rows: 0,
      infinite: false,
      speed: 400,
      swipeToSlide: true,
      arrows: true,
      prevArrow: $slider.closest('.news').find('[data-news-prev]'),
      nextArrow: $slider.closest('.news').find('[data-news-next]'),
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
  })
})
;(function () {
  const SPEED = 80

  document.querySelectorAll('[data-clients-marquee]').forEach((marquee) => {
    const track = marquee.querySelector('.clients__track')
    if (!track) return

    const originals = Array.from(track.children)
    if (!originals.length) return

    const build = () => {
      track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove())
      marquee.classList.remove('is-ready')

      const baseWidth = track.scrollWidth
      if (!baseWidth || !marquee.offsetWidth) return

      const repeats = Math.max(1, Math.ceil(marquee.offsetWidth / baseWidth))
      const fragment = document.createDocumentFragment()

      for (let i = 0; i < repeats * 2 - 1; i += 1) {
        originals.forEach((item) => {
          const clone = item.cloneNode(true)
          clone.setAttribute('data-marquee-clone', '')
          clone.setAttribute('aria-hidden', 'true')
          clone.setAttribute('tabindex', '-1')
          fragment.appendChild(clone)
        })
      }

      track.appendChild(fragment)
      track.style.setProperty('--marquee-duration', (baseWidth * repeats) / SPEED + 's')
      marquee.classList.add('is-ready')
    }

    build()

    window.addEventListener('load', build)

    let resizeTimer
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(build, 200)
    })
  })
})()
;(() => {
  const selects = document.querySelectorAll('.custom-select')
  if (!selects.length) return

  const close = (select) => {
    select.classList.remove('open')
    select.querySelector('.select-option_selected')?.setAttribute('aria-expanded', 'false')
  }

  const closeAll = (except) => {
    selects.forEach((select) => {
      if (select !== except) close(select)
    })
  }

  selects.forEach((select) => {
    const trigger = select.querySelector('.select-option_selected')
    const text = select.querySelector('.select-option-text')
    const dropdown = select.querySelector('.dropdown')
    if (!trigger || !dropdown) return

    trigger.setAttribute('role', 'button')
    trigger.setAttribute('tabindex', '0')
    trigger.setAttribute('aria-haspopup', 'listbox')
    trigger.setAttribute('aria-expanded', 'false')

    const toggle = () => {
      const open = !select.classList.contains('open')
      closeAll(select)
      select.classList.toggle('open', open)
      trigger.setAttribute('aria-expanded', String(open))
    }

    trigger.addEventListener('click', toggle)

    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return
      event.preventDefault()
      toggle()
    })

    dropdown.querySelectorAll('.select-option-link').forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href')

        select.querySelectorAll('.select-option').forEach((option) => {
          option.classList.toggle('is-selected', option.contains(link))
        })

        if (text) text.textContent = link.textContent.trim()
        close(select)
        trigger.focus()

        if (!href || href === '#') event.preventDefault()
      })
    })
  })

  document.addEventListener('click', (event) => {
    if (event.target.closest('.custom-select')) return
    closeAll()
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll()
  })
})()
;(() => {
  const fields = document.querySelectorAll('.contact-form__field--file')
  if (!fields.length) return

  fields.forEach((field) => {
    const input = field.querySelector('input[type="file"]')
    const label = field.querySelector('label')
    if (!input || !label) return

    const placeholder = label.textContent.trim()

    const sync = () => {
      const name = input.files && input.files[0] ? input.files[0].name : ''
      label.textContent = name || placeholder
      field.classList.toggle('is-filled', Boolean(name))
    }

    input.addEventListener('change', sync)
    input.form?.addEventListener('reset', () => requestAnimationFrame(sync))
  })
})()
;(() => {
  const header = document.getElementById('header')
  if (!header) return

  const menuToggle = header.querySelector('#menu-toggle')
  const tabletPanel = header.querySelector('#tablet-panel')
  const overlay = header.querySelector('#mobile-overlay')
  const overlayClose = header.querySelector('#mobile-close')
  const searchWidget = header.querySelector('#search-widget')
  const searchToggle = header.querySelector('#search-toggle')
  const searchInput = header.querySelector('#search-input')
  const searchSubmit = header.querySelector('.search-widget__submit')

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches
  const isDesktop = () => window.matchMedia('(min-width: 1280px)').matches

  const setDisclosure = (trigger, panel, open) => {
    if (!panel) return
    panel.classList.toggle('is-open', open)
    panel.inert = !open
    if (trigger) trigger.setAttribute('aria-expanded', String(open))
  }

  const panelOf = (trigger) => document.getElementById(trigger.getAttribute('aria-controls'))
  const isOpen = (trigger) => trigger.getAttribute('aria-expanded') === 'true'

  const groups = [
    header.querySelectorAll('.nav-desktop__trigger'),
    ...[...header.querySelectorAll('.accordion-nav')].map((nav) =>
      nav.querySelectorAll('.accordion-nav__trigger'),
    ),
  ]

  groups.forEach((triggers) => {
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const open = !isOpen(trigger)

        triggers.forEach((other) => {
          if (other !== trigger) setDisclosure(other, panelOf(other), false)
        })

        setDisclosure(trigger, panelOf(trigger), open)
      })
    })
  })

  const closeDropdowns = () => {
    header.querySelectorAll('.nav-desktop__trigger').forEach((trigger) => {
      setDisclosure(trigger, panelOf(trigger), false)
    })
  }

  const setSearch = (open) => {
    if (!searchWidget) return
    searchWidget.classList.toggle('is-open', open)
    searchToggle.setAttribute('aria-expanded', String(open))
    searchInput.inert = !open
    searchSubmit.inert = !open
    if (open) {
      closeDropdowns()
      searchInput.focus()
    }
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', () =>
      setSearch(!searchWidget.classList.contains('is-open')),
    )
  }

  const setMenu = (open) => {
    header.classList.toggle('is-menu-open', open)
    menuToggle.setAttribute('aria-expanded', String(open))
    menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu')

    if (overlay) overlay.inert = !(open && isMobile())
    setDisclosure(null, tabletPanel, open && !isMobile())

    document.body.style.overflow = open && isMobile() ? 'hidden' : ''

    if (open && isMobile() && overlayClose) overlayClose.focus()
  }

  const isMenuOpen = () => header.classList.contains('is-menu-open')

  if (menuToggle) {
    menuToggle.addEventListener('click', () => setMenu(!isMenuOpen()))
  }

  if (overlayClose) {
    overlayClose.addEventListener('click', () => {
      setMenu(false)
      menuToggle.focus()
    })
  }

  header.querySelectorAll('.tablet-panel a, .mobile-overlay a').forEach((link) => {
    link.addEventListener('click', () => setMenu(false))
  })

  document.addEventListener('click', (event) => {
    if (header.contains(event.target)) return
    closeDropdowns()
    setSearch(false)
    if (!isMobile()) setMenu(false)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return

    if (isMenuOpen()) {
      setMenu(false)
      menuToggle.focus()
      return
    }

    if (searchWidget && searchWidget.classList.contains('is-open')) {
      setSearch(false)
      searchToggle.focus()
      return
    }

    const openTrigger = header.querySelector('[aria-expanded="true"]')
    if (openTrigger) {
      setDisclosure(openTrigger, panelOf(openTrigger), false)
      openTrigger.focus()
    }
  })

  let wasDesktop = isDesktop()
  let wasMobile = isMobile()

  window.addEventListener('resize', () => {
    if (isDesktop() === wasDesktop && isMobile() === wasMobile) return
    wasDesktop = isDesktop()
    wasMobile = isMobile()
    if (isMenuOpen()) setMenu(false)
    closeDropdowns()
  })

  // const logos = [...header.querySelectorAll('.header__bar .header__logo img')]
  // if (!logos.length) return

  // const LOGO_REPLAY_INTERVAL = 5000

  // const replayLogos = () => {
  //   logos.forEach((logo) => {
  //     if (!logo.offsetParent) return
  //     logo.src = `${logo.src.split('?')[0]}?r=${Date.now()}`
  //   })
  // }

  // let logoTimer = setInterval(replayLogos, LOGO_REPLAY_INTERVAL)

  // document.addEventListener('visibilitychange', () => {
  //   clearInterval(logoTimer)
  //   if (!document.hidden) logoTimer = setInterval(replayLogos, LOGO_REPLAY_INTERVAL)
  // })
})()
;(() => {
  const footer = document.querySelector('.footer')
  if (!footer) return

  const triggers = footer.querySelectorAll('.footer-accordion__trigger')

  const setPanel = (trigger, open) => {
    const panel = document.getElementById(trigger.getAttribute('aria-controls'))
    if (!panel) return
    trigger.setAttribute('aria-expanded', String(open))
    panel.classList.toggle('is-open', open)
    panel.inert = !open
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const open = trigger.getAttribute('aria-expanded') !== 'true'

      triggers.forEach((other) => setPanel(other, false))
      if (open) setPanel(trigger, true)
    })
  })

  const logo = footer.querySelector('.footer__logo img')
  if (!logo || !logo.dataset.src) return

  if (!('IntersectionObserver' in window)) {
    logo.src = logo.dataset.src
    return
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        logo.src = `${logo.dataset.src}?r=${Date.now()}`
        obs.disconnect()
      })
    },
    { threshold: 0.4 },
  )

  observer.observe(logo)
})()
;(function () {
	'use strict';

	var controlStates = new WeakMap();
	var submitSelector = 'input[type="submit"], button[type="submit"]';

	function createSvg(className, pathData, isSpinner) {
		var namespace = 'http://www.w3.org/2000/svg';
		var svg = document.createElementNS(namespace, 'svg');
		var path = document.createElementNS(namespace, 'path');

		svg.setAttribute('class', className);
		svg.setAttribute('width', '16');
		svg.setAttribute('height', '16');
		svg.setAttribute('viewBox', '0 0 16 16');
		svg.setAttribute('fill', 'none');
		svg.setAttribute('aria-hidden', 'true');
		svg.setAttribute('focusable', 'false');

		if (isSpinner) {
			var circle = document.createElementNS(namespace, 'circle');

			circle.setAttribute('cx', '8');
			circle.setAttribute('cy', '8');
			circle.setAttribute('r', '6');
			circle.setAttribute('stroke', 'currentColor');
			circle.setAttribute('stroke-opacity', '.35');
			circle.setAttribute('stroke-width', '1.6');
			svg.appendChild(circle);
		}

		path.setAttribute('d', pathData);
		path.setAttribute('stroke', 'currentColor');
		path.setAttribute('stroke-width', '1.6');
		path.setAttribute('stroke-linecap', 'round');

		if (!isSpinner) {
			path.setAttribute('stroke-linejoin', 'round');
		}

		svg.appendChild(path);

		return svg;
	}

	function getOriginalLabel(control) {
		if ('INPUT' === control.tagName) {
			return control.value;
		}

		return Array.prototype.map.call(control.childNodes, function (node) {
			return node.cloneNode(true);
		});
	}

	function restoreOriginalLabel(control, originalLabel) {
		if ('INPUT' === control.tagName) {
			control.value = originalLabel;
			return;
		}

		control.replaceChildren();

		originalLabel.forEach(function (node) {
			control.appendChild(node.cloneNode(true));
		});
	}

	function setControlLabel(control, label) {
		if ('INPUT' === control.tagName) {
			control.value = label;
			return;
		}

		control.textContent = label;
	}

	function ensureControlState(control) {
		if (controlStates.has(control)) {
			return controlStates.get(control);
		}

		if (control.parentElement && control.parentElement.classList.contains('hmt-cf7-submit-state')) {
			var existingState = {
				wrapper: control.parentElement,
				originalLabel: getOriginalLabel(control),
				disabledBeforeLoading: control.disabled
			};

			controlStates.set(control, existingState);

			return existingState;
		}

		var wrapper = document.createElement('span');
		var spinner = createSvg('hmt-cf7-submit__spinner', 'M14 8a6 6 0 0 0-6-6', true);
		var check = createSvg('hmt-cf7-submit__check', 'm3 8.5 3.5 3.5L13 5', false);
		var state = {
			wrapper: wrapper,
			originalLabel: getOriginalLabel(control),
			disabledBeforeLoading: control.disabled
		};

		wrapper.className = 'hmt-cf7-submit-state';
		control.parentNode.insertBefore(wrapper, control);
		wrapper.appendChild(control);
		wrapper.appendChild(spinner);
		wrapper.appendChild(check);
		controlStates.set(control, state);

		return state;
	}

	function getForm(event) {
		if (!(event.target instanceof HTMLFormElement)) {
			return null;
		}

		return event.target.matches('.wpcf7 form') ? event.target : null;
	}

	function updateFormControls(form, status) {
		form.querySelectorAll(submitSelector).forEach(function (control) {
			var state = ensureControlState(control);

			state.wrapper.classList.remove('is-loading', 'is-submitted');

			if ('loading' === status) {
				state.disabledBeforeLoading = control.disabled;
				restoreOriginalLabel(control, state.originalLabel);
				control.setAttribute('aria-busy', 'true');
				control.disabled = true;
				state.wrapper.classList.add('is-loading');
				return;
			}

			if ('submitted' === status) {
				control.removeAttribute('aria-busy');
				setControlLabel(
					control,
					window.HMT_CF7 && window.HMT_CF7.submittedLabel
						? window.HMT_CF7.submittedLabel
						: 'Submitted'
				);
				control.disabled = state.disabledBeforeLoading;
				state.wrapper.classList.add('is-submitted');
				return;
			}

			restoreOriginalLabel(control, state.originalLabel);
			control.removeAttribute('aria-busy');
			control.disabled = state.disabledBeforeLoading;
		});
	}

	document.addEventListener('wpcf7beforesubmit', function (event) {
		var form = getForm(event);

		if (form) {
			updateFormControls(form, 'loading');
		}
	});

	document.addEventListener('wpcf7mailsent', function (event) {
		var form = getForm(event);

		if (form) {
			updateFormControls(form, 'submitted');
		}
	});

	['wpcf7invalid', 'wpcf7mailfailed', 'wpcf7spam'].forEach(function (eventName) {
		document.addEventListener(eventName, function (event) {
			var form = getForm(event);

			if (form) {
				updateFormControls(form, 'default');
			}
		});
	});

	document.addEventListener('wpcf7submit', function (event) {
		var form = getForm(event);

		if (!form) {
			return;
		}

		if (event.detail && 'mail_sent' === event.detail.status) {
			updateFormControls(form, 'submitted');
		} else {
			updateFormControls(form, 'default');
		}
	});

	document.addEventListener('wpcf7reset', function (event) {
		var form = getForm(event);

		if (!form) {
			return;
		}

		updateFormControls(form, 'sent' === form.dataset.status ? 'submitted' : 'default');
	});
}());
;(function () {
  'use strict'

  var MAP_BASE_FILL = '#D4D5D5'
  var MAP_HIGHLIGHT_FILL = '#FCA311'

  function hasValue(value) {
    return typeof value === 'string' ? value.trim().length > 0 : Boolean(value)
  }

  function isOfficeFilled(office) {
    return (
      Boolean(office) &&
      hasValue(office.city) &&
      hasValue(office.company) &&
      hasValue(office.address)
    )
  }

  function buildCountryLookup(section) {
    var dataScript = section.querySelector('#interactive-map-locations')
    var lookup = {}

    if (!dataScript) {
      return lookup
    }

    var regions

    try {
      regions = JSON.parse(dataScript.textContent)
    } catch (e) {
      return lookup
    }

    regions.forEach(function (region) {
      ;(region.countries || []).forEach(function (country) {
        var filledOffices = (country.offices || []).filter(isOfficeFilled)

        if (country.slug && filledOffices.length) {
          lookup[country.slug] = {
            name: country.name,
            slug: country.slug,
            offices: filledOffices
          }
        }
      })
    })

    return lookup
  }

  function syncCountryShapes(svg, countries) {
    svg.querySelectorAll('[data-country]').forEach(function (shape) {
      var key = shape.getAttribute('data-country')

      if (countries[key]) {
        shape.classList.add('interactive-map__country-shape')
        shape.style.fill = MAP_HIGHLIGHT_FILL
      } else {
        shape.removeAttribute('data-country')
        shape.classList.remove('interactive-map__country-shape')
        shape.style.fill = MAP_BASE_FILL
      }
    })
  }

  function renderPopup(popup, country) {
    var html =
      '<button type="button" class="interactive-map__popup-close" aria-label="Close">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M1 1L15 15" stroke="#0E1116" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M15 1L1 15" stroke="#0E1116" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</button>'

    html += '<p class="interactive-map__popup-title">' + country.name + '</p>'
    ;(country.offices || []).forEach(function (o) {
      html +=
        '<div class="interactive-map__popup-office">' +
        '<p class="interactive-map__popup-city">' +
        o.city +
        '</p>' +
        '<h5 class="interactive-map__popup-company">' +
        o.company +
        '</h5>' +
        '<p class="interactive-map__popup-address">' +
        o.address +
        '</p>' +
        '</div>'
    })

    popup.innerHTML = html
  }

  function positionPopup(popup, mapWrap, svg, shape) {
    var bbox = shape.getBBox()
    var vb = svg.viewBox.baseVal
    var leftPct = ((bbox.x + bbox.width / 2 - vb.x) / vb.width) * 100
    var topPct = ((bbox.y - vb.y) / vb.height) * 100
    var bottomPct = ((bbox.y + bbox.height - vb.y) / vb.height) * 100

    popup.classList.remove('interactive-map__popup--flip')
    popup.style.setProperty('--popup-shift-x', '0px')
    popup.style.left = leftPct + '%'
    popup.style.top = topPct + '%'
    popup.hidden = false

    var wrapRect = mapWrap.getBoundingClientRect()
    var popRect = popup.getBoundingClientRect()

    if (popRect.top < wrapRect.top) {
      popup.classList.add('interactive-map__popup--flip')
      popup.style.top = bottomPct + '%'
      popRect = popup.getBoundingClientRect()
    }

    var shiftX = 0

    if (popRect.left < wrapRect.left) {
      shiftX = wrapRect.left - popRect.left
    } else if (popRect.right > wrapRect.right) {
      shiftX = wrapRect.right - popRect.right
    }

    if (shiftX) {
      popup.style.setProperty('--popup-shift-x', shiftX + 'px')
    }
  }

  document.querySelectorAll('.interactive-map').forEach(function (section) {
    var svg = section.querySelector('.interactive-map__svg')
    var mapWrap = section.querySelector('.interactive-map__map')

    if (!svg || !mapWrap) {
      return
    }

    var countries = buildCountryLookup(section)

    syncCountryShapes(svg, countries)

    var popup = document.createElement('div')
    popup.className = 'interactive-map__popup'
    popup.hidden = true
    mapWrap.appendChild(popup)

    var listItems = section.querySelectorAll('.interactive-map__country[data-country]')
    var activeSlug = null

    function showAllOffices() {
      svg.querySelectorAll('[data-country]').forEach(function (el) {
        el.style.fill = MAP_HIGHLIGHT_FILL
      })
    }

    function showOnlyOffice(slug) {
      svg.querySelectorAll('[data-country]').forEach(function (el) {
        el.style.fill = el.getAttribute('data-country') === slug ? MAP_HIGHLIGHT_FILL : MAP_BASE_FILL
      })
    }

    function setActiveListItem(slug) {
      listItems.forEach(function (el) {
        el.classList.toggle('is-active', Boolean(slug) && el.getAttribute('data-country') === slug)
      })
    }

    function closePopup() {
      popup.hidden = true
      activeSlug = null
      showAllOffices()
      svg.querySelectorAll('.interactive-map__country-shape.is-active').forEach(function (el) {
        el.classList.remove('is-active')
      })
      setActiveListItem(null)
    }

    function selectCountry(slug, shapeForPositioning) {
      var country = countries[slug]

      if (!country) {
        return
      }

      if (activeSlug === slug) {
        closePopup()
        return
      }

      activeSlug = slug
      showOnlyOffice(slug)

      svg.querySelectorAll('.interactive-map__country-shape').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-country') === slug)
      })
      setActiveListItem(slug)

      renderPopup(popup, country)

      var shape = shapeForPositioning || svg.querySelector('[data-country="' + slug + '"]')

      if (shape) {
        positionPopup(popup, mapWrap, svg, shape)
      }
    }

    var hoveredKey = null

    function setHovered(countryKey) {
      if (countryKey === hoveredKey) {
        return
      }

      if (hoveredKey) {
        svg.querySelectorAll('[data-country="' + hoveredKey + '"]').forEach(function (el) {
          el.classList.remove('is-hovered')
        })
      }

      hoveredKey = countryKey

      if (hoveredKey) {
        svg.querySelectorAll('[data-country="' + hoveredKey + '"]').forEach(function (el) {
          el.classList.add('is-hovered')
        })
      }
    }

    svg.addEventListener('mouseover', function (event) {
      var shape = event.target.closest('[data-country]')
      setHovered(shape ? shape.getAttribute('data-country') : null)
    })

    svg.addEventListener('mouseout', function (event) {
      var next =
        event.relatedTarget && event.relatedTarget.closest
          ? event.relatedTarget.closest('[data-country]')
          : null

      if (!next || next.getAttribute('data-country') !== hoveredKey) {
        setHovered(null)
      }
    })

    svg.addEventListener('click', function (event) {
      var shape = event.target.closest('[data-country]')

      if (!shape) {
        return
      }

      selectCountry(shape.getAttribute('data-country'), shape)
    })

    listItems.forEach(function (countryEl) {
      countryEl.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) {
          return
        }

        var slug = countryEl.getAttribute('data-country')

        if (!slug || !countries[slug]) {
          return
        }

        selectCountry(slug)
        mapWrap.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    })

    popup.addEventListener('click', function (event) {
      if (event.target.closest('.interactive-map__popup-close')) {
        closePopup()
      }
    })

    document.addEventListener('click', function (event) {
      if (
        !popup.hidden &&
        !popup.contains(event.target) &&
        !event.target.closest('[data-country]')
      ) {
        closePopup()
      }
    })

    document.addEventListener('keydown', function (event) {
      if ('Escape' === event.key) {
        closePopup()
      }
    })
  })
})()
;(() => {
  document.querySelectorAll('.credentials').forEach((section) => {
    const triggers = section.querySelectorAll('.credentials__accordion-trigger');

    const setPanel = (trigger, open) => {
      const item = trigger.closest('.credentials__accordion-item');
      const panel = item && item.querySelector('.credentials__accordion-panel');
      if (!panel) return;
      trigger.setAttribute('aria-expanded', String(open));
      panel.classList.toggle('is-open', open);
      panel.inert = !open;
    };

    triggers.forEach((trigger) => {
      setPanel(trigger, trigger.getAttribute('aria-expanded') === 'true');
      trigger.addEventListener('click', () => {
        const open = trigger.getAttribute('aria-expanded') !== 'true';
        triggers.forEach((other) => {
          if (other !== trigger) setPanel(other, false);
        });
        setPanel(trigger, open);
      });
    });
  });
})();
;(() => {
  let youtubeReady;

  function loadYouTube() {
    if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
    if (youtubeReady) return youtubeReady;

    youtubeReady = new Promise((resolve, reject) => {
      const previousReady = window.onYouTubeIframeAPIReady;
      const timeout = setTimeout(() => reject(new Error('YouTube API unavailable')), 15000);
      window.onYouTubeIframeAPIReady = function () {
        clearTimeout(timeout);
        try {
          if (typeof previousReady === 'function') previousReady.apply(this, arguments);
        } finally {
          resolve(window.YT);
        }
      };

      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"], script[src="https://www.youtube.com/player_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.onerror = () => {
          clearTimeout(timeout);
          reject(new Error('YouTube API unavailable'));
        };
        document.head.appendChild(script);
      }
    });
    return youtubeReady;
  }

  document.querySelectorAll('.fullscreen-media').forEach((section) => {
    const video = section.querySelector('video.fullscreen-media__video');
    const youtube = section.querySelector('.fullscreen-media__youtube');
    const playButton = section.querySelector('.fullscreen-media__play');
    const overlay = section.querySelector('.fullscreen-media__overlay');
    if ((!video && !youtube) || !playButton || !overlay) return;

    const setPlaying = (playing) => {
      const restoreFocus = !playing && section.contains(document.activeElement);
      section.classList.toggle('is-playing', playing);
      overlay.inert = playing;
      if (video) {
        if (playing) video.setAttribute('controls', '');
        else video.removeAttribute('controls');
      }
      if (youtube) youtube.inert = !playing;
      if (playing && document.activeElement === playButton) {
        const playerElement = video || youtube.querySelector('iframe');
        if (playerElement) playerElement.focus();
      } else if (restoreFocus) {
        playButton.focus();
      }
    };

    if (video) {
      playButton.addEventListener('click', () => {
        setPlaying(true);
        const playback = video.play();
        if (playback) playback.catch(() => setPlaying(false));
      });
      video.addEventListener('play', () => setPlaying(true));
      ['pause', 'ended', 'error'].forEach((eventName) => {
        video.addEventListener(eventName, () => setPlaying(false));
      });
      return;
    }

    youtube.inert = true;
    let player;
    let playerReady = false;
    playButton.addEventListener('click', () => {
      if (playerReady) {
        setPlaying(true);
        player.playVideo();
        return;
      }
      playButton.disabled = true;
      playButton.setAttribute('aria-busy', 'true');
      loadYouTube().then((YT) => {
        player = new YT.Player(youtube.querySelector('[data-youtube-player]'), {
          videoId: youtube.dataset.youtubeId,
          playerVars: { playsinline: 1, autoplay: 0, rel: 0, origin: window.location.origin },
          events: {
            onReady: (event) => {
              playerReady = true;
              playButton.disabled = false;
              playButton.removeAttribute('aria-busy');
              event.target.getIframe().title = youtube.dataset.title;
              event.target.mute();
              setPlaying(true);
              event.target.playVideo();
            },
            onStateChange: (event) => {
              if (event.data === YT.PlayerState.PLAYING) setPlaying(true);
              if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) setPlaying(false);
            },
            onError: () => {
              playButton.disabled = false;
              playButton.removeAttribute('aria-busy');
              setPlaying(false);
            },
            onAutoplayBlocked: () => setPlaying(false),
          },
        });
      }).catch(() => {
        playButton.disabled = false;
        playButton.removeAttribute('aria-busy');
        setPlaying(false);
      });
    });
  });
})();
;(() => {
  const forms = document.querySelectorAll('.search-form--autocomplete')
  if (!forms.length) return

  forms.forEach((form) => {
    const field = form.querySelector('.search-form__field')
    const clear = form.querySelector('.search-form__clear')
    const options = [...form.querySelectorAll('.select-option')]
    if (!field) return

    const setOpen = (open) => {
      form.classList.toggle('is-open', open)
      field.setAttribute('aria-expanded', String(open))
    }

    const update = () => {
      const query = field.value.trim().toLowerCase()
      let matches = 0

      options.forEach((option) => {
        const match = query !== '' && option.textContent.toLowerCase().includes(query)
        option.hidden = !match
        if (match) matches++
      })

      form.classList.toggle('is-filled', field.value !== '')
      setOpen(matches > 0)
    }

    field.addEventListener('input', update)
    field.addEventListener('focus', update)

    form.querySelectorAll('.select-option-link').forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href')

        field.value = link.textContent.trim()
        form.classList.add('is-filled')
        setOpen(false)

        if (!href || href === '#') event.preventDefault()
      })
    })

    clear?.addEventListener('click', () => {
      field.value = ''
      update()
      field.focus()
    })

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) setOpen(false)
    })

    field.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false)
    })
  })
})()